import React, { useEffect, useState } from 'react';
import Chart from "react-apexcharts";

interface Iprops {
  data: any[];
  categories: any[];
  averageName: string;
  height?: number;
  xTitle?: string;
  xLabelRotate?: number;
  yTitle?: string;
  legend?: Boolean;
}

const LineChart = ({
  data,
  categories,
  averageName,
  height= 200,
  xTitle,
  xLabelRotate,
  yTitle,
  legend,
}: Iprops) => {
  
    const [options, setOptions] = useState<any>(
        {
            series: [{
                name: averageName,
                data: data
            }],
            chart: {
                height,
                type: 'line',
                zoom: {
                    enabled: false
                }
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'straight'
            },
            colors: ["#0EA5E9", "#EF4444"],
            // grid: {
            //     row: {
            //         colors: ['#f3f3f3', 'transparent'],
            //         opacity: 0.5
            //     },
            // },
            xaxis: {
                categories: categories,
                ...(xTitle ? {
                    title: {
                        text: xTitle,
                        style: {
                            fontWeight: 600,
                        },
                        offsetY: -10,
                    }
                } : {}),
                ...(xLabelRotate ? {
                    labels: { rotate: xLabelRotate }
                } : {}),
            },
            yaxis: {
                ...(yTitle ? {
                    title: {
                        text: yTitle,
                        style: {
                            fontWeight: 600,
                        },
                    }
                } : {}),
            },
            legend:{
                show:true,
            }
        }
    );

    useEffect(() => {
        setOptions((prevValues: any) => ({
            ...prevValues,
            series: [{
                name: averageName,
                data: data
            }],
            xaxis: {
                categories: categories
            }
        }))
    }, [data, categories, averageName]);
  
  return (
    <div className='line-chart-wrapper'>
      <Chart
        options={options}
        series={options.series}
        type="line"
        height={height}
      />
    </div> 
  )
}

export default LineChart